// context/PersonalizeModalContext.tsx
import React, { createContext, useContext, useState, useEffect } from 'react'

interface ProductData {
  product: any
  inputs: any
  isEdit?: string
}

interface ContextProps {
  isOpen: boolean
  productData: ProductData | null
  openModal: (data: ProductData) => void
  closeModal: () => void
  updateProductData: (updatedFields: Partial<ProductData['product']>) => void // Add this
}

const PersonalizeModalContext = createContext<ContextProps | undefined>(undefined)

export const PersonalizeModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [productData, setProductData] = useState<ProductData | null>(null)

  useEffect(() => {
    const saved = localStorage.getItem('personalizeModal')
    if (saved) {
      const parsed = JSON.parse(saved)
      setIsOpen(parsed.isOpen)
      setProductData(parsed.productData)
    }
  }, [])

  useEffect(() => {
    localStorage.setItem('personalizeModal', JSON.stringify({ isOpen, productData }))
  }, [isOpen, productData])

  const openModal = (data: ProductData) => {
    const normalizedData: ProductData = {
        ...data,
        isEdit: data.isEdit ?? '0', // default to '0' if not provided
    }
    setProductData(normalizedData)
    setIsOpen(true)
}

  const closeModal = () => {
    setProductData(null)
    setIsOpen(false)
    localStorage.removeItem('personalizeModal')
  }

  const updateProductData = (updatedFields: Partial<ProductData['product']>) => {
  setProductData(prev => {
    if (!prev) return prev
    const newItem = {
      ...prev,
      product: {
        ...prev.product,
        ...updatedFields,
      },
    }
    return {
      ...prev,
      product: {
        ...prev.product,
        ...updatedFields,
      },
    }
  })
}

  return (
    <PersonalizeModalContext.Provider 
      value={{ isOpen, productData, openModal, closeModal, updateProductData }}
    >
      {children}
    </PersonalizeModalContext.Provider>
  )
}

export const usePersonalizeModal = () => {
  const context = useContext(PersonalizeModalContext)
  if (!context) {
    throw new Error('usePersonalizeModal must be used within PersonalizeModalProvider')
  }
  return context
}
